"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.guidesReducer = void 0;
var redux_1 = require("redux");
var Pages_1 = require("@/rendering/common/Pages");
var HeaderSection_init_1 = require("@/pages/guides/states/HeaderSection.init");
var SearchSection_init_1 = require("@/pages/guides/states/SearchSection.init");
var Menu_init_1 = require("@/pages/guides/states/Menu.init");
var SubHeaderSection_init_1 = require("@/pages/guides/states/SubHeaderSection.init");
var Guides_init_1 = require("@/pages/guides/states/Guides.init");
var GuidesDistricts_init_1 = require("@/pages/guides/states/GuidesDistricts.init");
var actions_1 = require("@/pages/guides/actions/actions");
var typesafe_actions_1 = require("typesafe-actions");
var RootPublicPageReducer_1 = require("@/pages/common/reducers/RootPublicPageReducer");
exports.guidesReducer = {
    page: function (state) {
        if (state === void 0) { state = Pages_1.Pages.GUIDES; }
        return state;
    },
    headerSection: function (state) {
        if (state === void 0) { state = HeaderSection_init_1.defaultHeaderSection; }
        return state;
    },
    searchSection: function (state) {
        if (state === void 0) { state = SearchSection_init_1.defaultSearchSection; }
        return state;
    },
    menu: function (state) {
        if (state === void 0) { state = Menu_init_1.defaultMenu; }
        return state;
    },
    subHeaderSection: function (state) {
        if (state === void 0) { state = SubHeaderSection_init_1.defaultSubHeaderSection; }
        return state;
    },
    guides: function (state) {
        if (state === void 0) { state = Guides_init_1.defaultGuides; }
        return state;
    },
    guidesDistricts: function (state) {
        if (state === void 0) { state = GuidesDistricts_init_1.defaultGuidesDistricts; }
        return state;
    },
};
var combinedReducer = redux_1.combineReducers(__assign(__assign({}, RootPublicPageReducer_1.default), exports.guidesReducer));
var rootGuidesReducer = function (state, action) {
    switch (action.type) {
        case typesafe_actions_1.getType(actions_1.default.setSearchText): {
            return __assign(__assign({}, state), { searchSection: __assign(__assign({}, state.searchSection), { searchText: action.payload }) });
        }
        case typesafe_actions_1.getType(actions_1.default.setSearchKeywords): {
            return __assign(__assign({}, state), { searchSection: __assign(__assign({}, state.searchSection), { searchKeywords: __spreadArrays(action.payload) }) });
        }
        case typesafe_actions_1.getType(actions_1.default.reloadItems): {
            return __assign(__assign({}, state), { guides: __assign(__assign({}, state.guides), { items: __spreadArrays(action.payload) }) });
        }
        case typesafe_actions_1.getType(actions_1.default.reloadPager): {
            return __assign(__assign({}, state), { guides: __assign(__assign({}, state.guides), { pager: __assign({}, action.payload) }) });
        }
        case typesafe_actions_1.getType(actions_1.default.resetMenu): {
            return __assign(__assign({}, state), { menu: state.menu.map(function (item) { return (__assign(__assign({}, item), { subItems: item.subItems.map(function (sub) { return (__assign(__assign({}, sub), { current: false })); }) })); }) });
        }
        case typesafe_actions_1.getType(actions_1.default.resetHeader): {
            return __assign(__assign({}, state), { subHeaderSection: __assign(__assign({}, state.subHeaderSection), { title: null, paragraph: null, keyword: action.payload }) });
        }
        case typesafe_actions_1.getType(actions_1.default.resetDistricts): {
            return __assign(__assign({}, state), { guidesDistricts: {
                    imageUrl: null,
                    districts: null,
                } });
        }
        case 'SET_ALL_STATE_GUIDES': {
            return __assign(__assign({}, state), action.payload);
        }
        default:
            return combinedReducer(state, action);
    }
};
exports.default = rootGuidesReducer;
